import { render } from "./CostReportDetailsClass.vue?vue&type=template&id=bb0cd29c&scoped=true"
import script from "./CostReportDetailsClass.vue?vue&type=script&lang=js"
export * from "./CostReportDetailsClass.vue?vue&type=script&lang=js"

import "./CostReportDetailsClass.vue?vue&type=style&index=0&id=bb0cd29c&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb0cd29c"]])

export default __exports__